import { motion } from 'framer-motion';

const PrivacyPolicy = () => {
  return (
    <div className="min-h-screen bg-[#F8F3F0] pt-24 pb-16">
      <div className="container mx-auto px-4">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          className="max-w-3xl mx-auto bg-white rounded-2xl p-8 shadow-lg"
        >
          <h1 className="text-3xl font-bold text-[#4A3B36] mb-8">Política de Privacidade</h1>
          
          <div className="space-y-6 text-[#6B5C57]">
            <section>
              <h2 className="text-xl font-semibold text-[#4A3B36] mb-3">1. Introdução</h2>
              <p className="leading-relaxed">
                Esta Política de Privacidade descreve como suas informações pessoais são coletadas, 
                usadas e compartilhadas quando você utiliza nossos serviços de psicologia.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-[#4A3B36] mb-3">2. Informações que Coletamos</h2>
              <p className="leading-relaxed">
                Coletamos apenas as informações necessárias para a prestação dos serviços de psicologia, incluindo:
              </p>
              <ul className="list-disc pl-6 mt-2 space-y-2">
                <li>Informações de contato (nome, telefone, e-mail)</li>
                <li>Informações necessárias para o prontuário</li>
                <li>Dados relevantes para o processo terapêutico</li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-[#4A3B36] mb-3">3. Como Usamos suas Informações</h2>
              <p className="leading-relaxed">
                Suas informações são utilizadas exclusivamente para:
              </p>
              <ul className="list-disc pl-6 mt-2 space-y-2">
                <li>Prestação dos serviços de psicologia</li>
                <li>Comunicação sobre suas sessões</li>
                <li>Manutenção do prontuário conforme exigido pelo CFP</li>
                <li>Cumprimento de obrigações legais e éticas</li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-[#4A3B36] mb-3">4. Sigilo Profissional</h2>
              <p className="leading-relaxed">
                Todas as informações compartilhadas durante as sessões são protegidas pelo sigilo 
                profissional, conforme estabelecido pelo Código de Ética Profissional do Psicólogo 
                e pela legislação vigente.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-[#4A3B36] mb-3">5. Proteção de Dados</h2>
              <p className="leading-relaxed">
                Implementamos medidas de segurança para proteger suas informações contra acesso, 
                alteração, divulgação ou destruição não autorizada.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-[#4A3B36] mb-3">6. Seus Direitos</h2>
              <p className="leading-relaxed">
                Você tem direito a:
              </p>
              <ul className="list-disc pl-6 mt-2 space-y-2">
                <li>Acessar seus dados pessoais</li>
                <li>Solicitar correções de informações</li>
                <li>Solicitar a exclusão de dados (respeitando as obrigações legais)</li>
                <li>Ser informado sobre o uso de seus dados</li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-[#4A3B36] mb-3">7. Contato</h2>
              <p className="leading-relaxed">
                Para questões sobre esta política ou sobre seus dados pessoais, entre em contato através do WhatsApp 
                ou email disponíveis em nosso site.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-[#4A3B36] mb-3">8. Atualizações</h2>
              <p className="leading-relaxed">
                Esta política pode ser atualizada periodicamente. Recomendamos que você revise 
                regularmente para se manter informado sobre como protegemos suas informações.
              </p>
            </section>

            <div className="text-sm text-[#6B5C57] mt-8 pt-4 border-t border-[#D4B4A8]/20">
              Última atualização: {new Date().toLocaleDateString()}
            </div>
          </div>
        </motion.div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
